import styled from '@emotion/styled'
import { type statusBgKey, statusBgs } from 'commons/styles/StatusBG'
import { theme } from 'styles/theme/hav-theme'

interface StatusProps {
  status: statusBgKey
}

export const Container = styled.div<StatusProps>`
  color: white;
  font-size: ${theme.typography.sizes['2xs']};
  font-weight: ${theme.typography.weight.md};
  display: flex;
  place-content: center;
  align-items: center;
  padding: ${theme.spacing.xs};
  width: fit-content;
  height: ${theme.spacing.xm};

  background: ${({ status }) => statusBgs[status]};
  border-radius: 2px;
  margin: ${theme.spacing.xs} 0px;
`
